function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 19.9c.6.1.9.4 1.1.6 1.4 1.1 4.2 3.2 4.2 3.2.2.2.7.3.9.3h.1c.6 0 1.1-.4 1.1-1V3.7c0-2-1.7-3.7-3.7-3.7H3.6C1.6 0 0 1.6 0 3.7v12.5c0 2 1.7 3.7 3.7 3.7",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24"
  }, props), _ref);
};

export default SvgComponent;